<script>
export default {
    name: 'IconCp'
}
</script>
<template>
    <svg
        class="base-icon icon-cp"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M27.084 28C36 28 43 34 46.168 42 43.62 50.113 36.04 56 27.084 56 18.13 56 10.55 50.114 8 42c2.548-8.114 10.5-14 19.084-14zm.332 6c-2.945 0-5.332 2.225-5.332 4.966V50h3.851v-4.414h2.963V50h3.853V38.966c0-2.741-2.39-4.966-5.335-4.966zm0 3.585c.818 0 1.482.62 1.482 1.38v3.31h-2.963v-3.31c0-.76.663-1.38 1.48-1.38zM27.084 8a8 8 0 110 16 8 8 0 010-16zM56 8v12.387H43.5L40 24V8h16z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
